import React from 'react';
import type { FooterMoreSmallProps } from './types';
import {
  bridge,
  isNil,
  isNotNil,
} from '../../../../utils';
import { useOpenDeeplink } from '../../../../hooks/useOpenDeeplink';
import type { IScreensLogging } from '../../../../api/types';
import { Flex, PrimaryButton } from '@banhala/ui-kit';

export const FooterMoreSmall = ({ footer, screen }: FooterMoreSmallProps) => {
  const { openDeeplink } = useOpenDeeplink();

  if (isNil(footer)) return null;

  const handleClickViewAllButton = () => {
    const { deeplink } = footer.item;
    if (deeplink === null) {
      return;
    }

    logClickViewAllButton({ logging: footer.logging, screen });

    openDeeplink(deeplink);
  };

  return (
    <Flex padding={{ horizontal: 16 }} margin={{ top: footer.item.margin_top }}>
      <PrimaryButton
        color="gray"
        size="medium"
        variant={'fill'}
        outline
        onPress={handleClickViewAllButton}
      >
        {footer.item.title}
      </PrimaryButton>
    </Flex>
  );
};

const logClickViewAllButton = ({
  logging,
  screen,
}: {
  logging: IScreensLogging;
  screen?: string;
}) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_MORE_SMALL',
    analytics: {
      ...(isNotNil(screen) && { SCREEN: screen }),
      ...logging.analytics,
    },
    ably_only_log: logging.ably_only_log,
  });
};
